import AdvancedController from "./advanced-controller"
import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

export default class ChildPageController extends AdvancedController {

  static targets = ['item', 'section'];



  connect() {
    super.connect(...arguments);
    this.disableScrollValue = false;
    this.scroll();
  }

  scroll() {
    this.sectionTargets.forEach(section => {

      let indexOfSection = this.sectionTargets.indexOf(section);
      let item = this.itemTargets[indexOfSection];
      // for class toggling - we'll trigger when it's 40% from the top
      ScrollTrigger.create({
        trigger: section,
        start: "top 30%",
        end: "bottom center",
        onEnter: () => {
          //remove previous active
          this.itemTargets.forEach((itemTarget) => {
            itemTarget.classList.remove('active');
          });
          if (item.classList.contains('active')) return;
          item.classList.add('active');
          if (this.disableScrollValue) return;
          this.swipeToSlide(indexOfSection);
        },
        onEnterBack: () => {
          //remove previous active
          this.itemTargets.forEach((itemTarget) => {
            itemTarget.classList.remove('active');
          });
          if (item.classList.contains('active')) return;
          item.classList.add('active');
          if (this.disableScrollValue) return;
          this.swipeToSlide(indexOfSection);
        }

      }
      );

    })
  }

  swipeToSlide(index) {
    this.getAllControllers('swiper')[0].slideTo(index);
  }

  scrollToSection(index) {
    this.disableScrollValue = true;
    const selectedItem = this.sectionTargets[index];

    let header = document.querySelector('header').offsetHeight;
    let childPageNav = document.querySelector('.child-pages-slider').offsetHeight;
    let offset = header + childPageNav;

    this.scrollTo(selectedItem, -offset);
    setTimeout(() => {
      this.disableScrollValue = false;
    }, 1000);

  }

  scrollTo(selector, yOffset = 0) {
    const y = selector.getBoundingClientRect().top + window.scrollY + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }

}
